/* ==========================================================================
   VELDORO Home, behaviour for the veldoro-* homepage sections
   Only two things need JS: the promo slider and the newsletter form state.
   Everything else is CSS scroll-snap so it keeps working without JS.
   ========================================================================== */

(function () {
  'use strict';

  // Each section emits its own script tag, so this file can be included
  // several times on one page. Every tag executes, which would register
  // duplicate document-level listeners. Run the body once.
  if (window.__veldoroHomeReady) return;
  window.__veldoroHomeReady = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Swipe -------------------------------------------------------------
     Horizontal drag detection for touch devices. Ignores mostly-vertical
     movement so the page can still be scrolled from on top of the slider.
     ---------------------------------------------------------------------- */

  function onSwipe(el, handler) {
    var startX = 0;
    var startY = 0;
    var tracking = false;
    var THRESHOLD = 40;

    el.addEventListener('touchstart', function (event) {
      if (event.touches.length !== 1) return;
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
      tracking = true;
    }, { passive: true });

    el.addEventListener('touchend', function (event) {
      if (!tracking) return;
      tracking = false;

      var touch = event.changedTouches[0];
      var dx = touch.clientX - startX;
      var dy = touch.clientY - startY;

      if (Math.abs(dx) < THRESHOLD || Math.abs(dx) < Math.abs(dy)) return;
      handler(dx < 0 ? 1 : -1);
    }, { passive: true });
  }

  /* ---- Promo slider ---------------------------------------------------- */

  function PromoSlider(root) {
    this.root = root;
    this.track = root.querySelector('[data-promo-track]');
    this.slides = Array.prototype.slice.call(root.querySelectorAll('[data-promo-slide]'));
    this.dots = Array.prototype.slice.call(root.querySelectorAll('[data-promo-dot]'));
    this.index = 0;
    this.timer = null;
    this.interval = parseInt(root.dataset.autoplayInterval, 10) || 0;

    if (this.slides.length <= 1) {
      if (this.dots.length) this.dots.forEach(function (d) { d.hidden = true; });
      return;
    }

    this.bind();
    this.start();
  }

  PromoSlider.prototype.bind = function () {
    var self = this;

    this.dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        self.goTo(i);
        self.restart();
      });
    });

    // Pause while the pointer or keyboard focus is inside the slider.
    ['mouseenter', 'focusin'].forEach(function (evt) {
      self.root.addEventListener(evt, function () { self.stop(); });
    });
    ['mouseleave', 'focusout'].forEach(function (evt) {
      self.root.addEventListener(evt, function () { self.start(); });
    });

    // Don't run animations while the tab is in the background.
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) self.stop();
      else self.start();
    });

    // Swipe between slides on touch devices.
    onSwipe(this.root, function (direction) {
      self.goTo(self.index + direction);
      self.restart();
    });
  };

  PromoSlider.prototype.goTo = function (i) {
    this.index = (i + this.slides.length) % this.slides.length;
    this.track.style.transform = 'translateX(' + -this.index * 100 + '%)';

    this.dots.forEach(function (dot, d) {
      dot.setAttribute('aria-current', d === this.index ? 'true' : 'false');
    }, this);

    this.slides.forEach(function (slide, s) {
      slide.setAttribute('aria-hidden', s === this.index ? 'false' : 'true');
    }, this);
  };

  PromoSlider.prototype.start = function () {
    if (!this.interval || reduceMotion || this.timer) return;
    var self = this;
    this.timer = setInterval(function () { self.goTo(self.index + 1); }, this.interval);
  };

  PromoSlider.prototype.stop = function () {
    if (!this.timer) return;
    clearInterval(this.timer);
    this.timer = null;
  };

  PromoSlider.prototype.restart = function () {
    this.stop();
    this.start();
  };

  /* ---- Newsletter -------------------------------------------------------- */

  function initNewsletter(form) {
    var field = form.querySelector('input[type="email"]');
    if (!field) return;

    form.addEventListener('submit', function (event) {
      // Let Shopify handle the real submit; only block obviously empty input
      // so the customer gets feedback without a page round-trip.
      if (!field.value.trim()) {
        event.preventDefault();
        field.focus();
      }
    });
  }

  /* ---- Boot -------------------------------------------------------------- */

  function init(scope) {
    var root = scope || document;

    root.querySelectorAll('[data-promo-slider]').forEach(function (el) {
      if (el.dataset.veldoroInit === 'true') return;
      el.dataset.veldoroInit = 'true';
      new PromoSlider(el);
    });

    root.querySelectorAll('[data-veldoro-newsletter]').forEach(function (el) {
      if (el.dataset.veldoroInit === 'true') return;
      el.dataset.veldoroInit = 'true';
      initNewsletter(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Re-run when a section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
